import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateContacts } from '@/modules/Contact/gql/contact.gql'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchContact extends Vue {
  candidatesContact: Contact[] = []

  get candidatesContactOptions () {
    return this.candidatesContact.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async getCandidateContacts (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateContacts,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: 0,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesContact = result.data.getContacts.contacts
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
